import React, { Component } from 'react';

import WidgetService from "../../../../core/services/widgetService";
import styles from './resolution.scss';
import { resolutionList } from "../../../../core/constants/resolutions";

export default class Resolutions extends Component {
  constructor(props) {
    super(props);
    const widget = WidgetService.getWidget(this.props.widgetId);
    this.state = {
      showMenu: false,
      resolution: widget.metaData.resolution
    };

    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  getEnabledResolutions() {
    const widget = WidgetService.getWidget(this.props.widgetId);
    if (widget.metaData.resolutionList) {
      return resolutionList.filter(r => r === null || (r && widget.metaData.resolutionList[r[0]]));
    }

    return resolutionList;
  }

  showMenu(event) {
    let offset = window.innerHeight - event.pageY - 350;
    if ($("#preview-widget")[0]) {
      offset = -300;
    }
    this.menuTop = offset < 0 ? offset : 0;
    $(this.refs.container).parents("li").css("z-index", 55);
    event.preventDefault();
    this.setState({ showMenu: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu(event) {
    if (event === null || !this.dropdownMenu.contains(event.target)) {
      this.setState({ showMenu: false }, () => {
        document.removeEventListener('click', this.closeMenu);
        this.resetZIndex();
      });
    }
  }

  change(resolution) {
    this.setState({ resolution, showMenu: false }, () => {
      document.removeEventListener('click', this.closeMenu);
      this.resetZIndex();
    });
    this.props.changeResolution(resolution);
    this.resetZIndex();
  }

  resetZIndex() {
    const widgetContainer = $(this.refs.container).parents("li")[0];
    if (!$(widgetContainer).hasClass("maximized")) {
      $(widgetContainer).css("z-index", "");
    }
  }

  render() {
    return (
      <div className={this.props.isVertical ? styles.containerVertical : styles.container} ref="container">
        <button className={styles.button} onClick={this.showMenu}>
          {this.state.resolution ? this.state.resolution[4] : 'tick'}
        </button>
        {
          this.state.showMenu ?
            <div
              className={styles.menu}
              style={{ top: this.menuTop }}
              ref={(element) => {
                this.dropdownMenu = element;
              }}>
              {this.getEnabledResolutions().map((r, i) => {
                let style = styles.option;
                if (r && this.state.resolution && r[0] === this.state.resolution[0]) {
                  style = styles.optionSelected;
                }
                return r ? <div className={style} onClick={() => this.change(r)} key={i}>{r[0]}</div> :
                  <div className={styles.separator} key={i} />
              }
              )}
            </div>
            : null
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/timeseries-chart/resolutions.js